import { useState, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { AntarcticaMark } from "./AntarcticaMark";
import { SettingsDialog } from "./SettingsDialog";
import type { CurrentUser } from "../types/ride";

export function AppShell({ user, children }: { user: CurrentUser; children: ReactNode }) {
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <div className="flex min-h-screen flex-col">
      <header className="flex items-center justify-between border-b border-slate-200 bg-white px-4 py-3 dark:border-night-800 dark:bg-night-900 sm:px-6">
        <Link to="/" className="flex items-center gap-2">
          <AntarcticaMark className="h-6 w-6 text-black dark:text-white" />
          <span className="text-lg font-semibold tracking-tight">Hudson</span>
        </Link>
        <button
          type="button"
          onClick={() => setSettingsOpen(true)}
          aria-label="Settings"
          title="Settings"
          className="rounded-full p-2 text-xl text-slate-500 transition hover:bg-slate-100 dark:text-night-400 dark:hover:bg-night-800"
        >
          ⚙️
        </button>
      </header>

      <main className="flex-1">{children}</main>

      <SettingsDialog open={settingsOpen} onClose={() => setSettingsOpen(false)} user={user} />
    </div>
  );
}
